import { redirect, RouteObject } from 'react-router';
import { PATHS } from '~fpu/config/constants';

export const PERMANENT_REDIRECTS: RouteObject[] = [
  {
    path: 'coordinator',
    loader: () => {
      return redirect(PATHS.FPU_DASHBOARD.BASE, { status: 301 });
    }
  },
  {
    path: 'coordinator/promo',
    loader: () => {
      return redirect(PATHS.FPU_DASHBOARD.COORDINATOR_PROMO, { status: 301 });
    }
  }
];
